"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueToBool_1 = __importDefault(require("../lib/valueToBool"));
const registries_1 = require("../registries");
registries_1.functionRegistry.set('i', (context, args) => {
    if (valueToBool_1.default(context.getValueOfVariable(args[0]))) {
        return context.getValueOfVariable(args[1]);
    }
    else {
        return context.getValueOfVariable(args[2]);
    }
});
